// extracted by mini-css-extract-plugin
module.exports = {"swatch":"Swatch_swatch__XkJZq"};